import React, { useEffect, useRef, useState } from "react";
import { FlatList, ImageBackground, Pressable, ScrollView, StyleSheet, Switch, Text, TextInput as ReactText, 
  TouchableOpacity, View, Alert, NativeSyntheticEvent, TextInputKeyPressEventData } from "react-native";
import { MyButton, TextInputTemp } from "./buttonsAndControls";
import { Checkbox, IconButton, Modal, Portal, TextInput, Provider as PaperProvider } from "react-native-paper";
import DropDownPicker from "react-native-dropdown-picker";
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage";
import { branch, companyDir, company_Address, company_Name, company_Phone, header, profileName } from "./StockAwareTempData";
import Backdated from "./DateTimeCheck";
import createAndSavePDF from "./pdfCreate";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, getFirestore, limit, query, serverTimestamp, updateDoc, where } from "firebase/firestore";
import axios from 'axios'

const darkColour='#2a2d3e';

interface ChildViewData {
  id: string;
  texts: string[];
}

interface StockList {
  quantity: number;
  itemName: string;
	itemPrice: number;
}

interface salesDataInterface {
  qty: string;
  desc: string;
	amt: string;
}

interface SellList {
  quantity: number;
  itemName: string;
	notes: string;
  delivered: string;
	itemPrice: number;
  subTotal: number;
  discount: number;
  afterDiscount: number;
}


const ToBeSold = ({ texts, delPressed, isChecked, onCheckboxChange, index, }
  : ChildViewData & { delPressed: () => void, isChecked: boolean; onCheckboxChange: (value: boolean) => void; index: number; }) => {

  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
	const [hovered, setHovered] = useState(false);
	const [isOpacity, setIsOpacity] = useState(false);
  const sizes: number[] = [57, 290, 300, 100, 150];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity>
			<Pressable style={{...stylesBox.purchasedTouchable,  
          backgroundColor: hovered ? '#CCCCCC' : 'transparent', 
          opacity: isOpacity ? 0.2 : 1 }}
        onHoverIn={() => setHovered(true)}
        onHoverOut={() => setHovered(false)}
        onPressIn={() => setIsOpacity(true)}
        onPressOut={() => setIsOpacity(false)}
			>
        {texts.map((text, i) => (
          <View key={i} style={{...stylesBox.viewStyle, width: sizes[i] }} >
            <Text key={i} style={stylesBox.textStyle}>
              {text}
            </Text>
          </View>
        ))}
        <View style ={{width:38, height:35, borderWidth:0, borderRightWidth:2, borderColor:'black', }}>
          <Checkbox
            status={isChecked ? 'checked' : 'unchecked'}
            onPress={() => onCheckboxChange(!isChecked)}
            color= {darkColour}
          />
        </View>
				{hovered &&
          <IconButton icon={'trash-can-outline'} size={25} focusable={false} iconColor={darkColour}  
          style={stylesBox.iconButtonStyle}
          onPress={() => delPressed()}
				/>
				}
				</Pressable>
      </TouchableOpacity>
    </View>
  );
};

const ChildView = ({ texts, isChecked, isZero, onCheckboxChange, showCheckbox, index, clickedItem, name,
}: ChildViewData & { isChecked: boolean; isZero: boolean; onCheckboxChange: () => void; showCheckbox: boolean;
  index: number; clickedItem: (name: string, checked: boolean)=> void; name: string; }) => {

  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isZero ? 'red' : isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const [hovered, setHovered] = useState(false);
	const [isOpacity, setIsOpacity] = useState(false);
	const remarkWidth= showCheckbox ? 155 : 191
  const sizes: number[] = [57, 340, remarkWidth ];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity>
				<Pressable style={{... stylesBox.childPressable, backgroundColor: isChecked 
						? darkColour : hovered ? '#CCCCCC' : 'transparent', opacity: isOpacity ? 0.2 : 1}}
					onPress={() => {onCheckboxChange(); clickedItem(name, isChecked);}}
					onHoverIn={() => setHovered(true)}
					onHoverOut={() => setHovered(false)}
					onPressIn={() => setIsOpacity(true)}
					onPressOut={() => setIsOpacity(false)}
				>
        {showCheckbox && (
          <Checkbox
            status={isChecked ? 'checked' : 'unchecked'}
            onPress={() => {onCheckboxChange(); clickedItem(name, isChecked);}}
            color= {darkColour}
          />
        )}
        {texts.map((text, i) => (
          <View key={i} style={{...stylesBox.viewStyle, width: sizes[i] }}>
            <Text key={i} style={{...stylesBox.textStyle, color: isChecked ? 'white' : darkColour }}>
              {text}
            </Text>
          </View>
        ))}

				</Pressable>
      </TouchableOpacity>
    </View>
  );
};

const NewSales = () => {
  header('Sales')
  const [checkedItems, setCheckedItems] = useState<boolean[]>([]);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [markedID, setMarkedID] = useState<boolean[]>([]);
	const [filteredResult, setFilteredResult] = useState<StockList[]>([]);
	const [stocks, setStocks] = useState<StockList[]>([]);
	const [sellItems, setSellItems] = useState<SellList[]>([]);
	const [sellQty, setSellQty] = useState('')
	const [notesText, setNotesText] = useState('')
	const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({name: '', price: '', totalQuantity: ''})
  const qtyRef = useRef<ReactText>(null);
  const [oneOnly, setOneOnly] = useState('');
  const [totalDue, setTotalDue] = useState(' ');
  const computerDateTime = new Date();
  const [resultReceived, setResultReceived] = useState('');
  const [result, setResult] = useState('');
  const [showBackdated, setShowBackdated] = useState(true)
  const [salesData, setSalesData] = useState<salesDataInterface[]>([]);
  const receiptData = ({
    name: '', address: '', phone: '', salesID: '', salesPerson: '', date: '', payment: '', customer: '', total: '', discount: '', totalPaid: ''
  })
  const [phoneOptionalError, setPhoneOptionalError] = useState(false)
  const [errorPhone, setErrorPhone] = useState(false);
  const db = getFirestore();
	
  const fetchStocks = async () => {
    try {
      const stocksCollectionRef = collection(db, companyDir, branch, 'stocks'); // Replace 'stocks' with your actual Firestore collection name
      const querySnapshot = await getDocs(stocksCollectionRef);
  
      const stocksArray = [];
      const checkedItemsArray = [];
  
      querySnapshot.forEach((doc) => {
        const stockData = doc.data();
        stocksArray.push(stockData);
        checkedItemsArray.push(false); // Set initial checked state to false
      });
  
      setStocks(stocksArray);
      setFilteredResult(stocksArray);
      setCheckedItems(checkedItemsArray);
    } catch (error) {
      console.error('Error fetching data from Firestore', error);
    }
  };

  useEffect(() => {
    try {
      fetchStocks();
      }
      catch (error) {
        console.log(error)
      }
    }, []);

    useEffect(() => {
      let amt = 0
      {sellItems.forEach((row) => {
        if (!isNaN(row.subTotal) ){
        amt = amt + row.subTotal
        } 
        }, [sellItems])
      }
    setTotalDue(amt.toString())
    })
    		
		const qtyInput = (value: string) => {
			setSellQty(value)
		}

		const SmallDialog = (itemName: string, itemPrice: number, totalQuantity: number) => {
			setSelectedItem({name: itemName, price: itemPrice.toString(), totalQuantity: totalQuantity.toString()})
			setShowModal(true)
      setTimeout(() => {
       if (qtyRef.current) {
        qtyRef.current.focus()
       }
      }, 500); 
		}

    const handleAddItem = () => {
      setHandleChecked(true)
      const newItem: SellList = {
        quantity: parseInt(sellQty, 10),
        itemName: selectedItem.name,
        notes: notesText,
        delivered: handleChecked ?'Yes' : 'No',
        itemPrice: parseInt(selectedItem.price, 10),
        subTotal: parseInt(sellQty, 10) * parseInt(selectedItem.price, 10),
        discount: 0,
        afterDiscount: 0
      };
      if (parseInt(sellQty, 10) > parseInt(selectedItem.totalQuantity, 10)) {
        window.alert (`Not enough boards!\nThe quantity entered is greater than the number of ${selectedItem.name} available`)
      } else if (sellQty.charAt(0) === '0') {
        window.alert ('Zero is nothing\nEnter at least value of "1"')
      } else if (sellQty.trim() === ''|| isNaN(parseInt(sellQty, 10))) {
        window.alert ('Ooops!\nYou have not entered any number')
      } else {
        const existingItemIndex = sellItems.findIndex((item) => item.itemName === newItem.itemName);
        if (existingItemIndex !== -1) {
          const updatedSellItems = [...sellItems];
          updatedSellItems[existingItemIndex] = newItem;
          setSellItems(updatedSellItems);
        } else {
          setSellItems([...sellItems, newItem]);
        }

        const newSalesData = {
          qty: newItem.quantity.toString(),
          desc: newItem.itemName,
          amt: String(Number(newItem.subTotal).toLocaleString('en-NG', {})),
        }          

        const existingSalesData = salesData.findIndex((item) => item.desc === newItem.itemName);
        
        if (existingSalesData !== -1) {
          const updatedSalesData = [...salesData];
          updatedSalesData[existingSalesData] = newSalesData;
          setSalesData(updatedSalesData); // Update salesData with the updated array
        } else {
          setSalesData([...salesData, newSalesData]);
        }

        console.log(salesData)
        
        setShowModal(false)
        setSellQty('')
        setNotesText('')
        setOneOnly('')
      //  setAmountDue(parseInt(sellQty, 10) * parseInt(selectedItem.price, 10))
      }
    };
    
	  
  const handleSearchTextChange = (value: string) => {
    setSearchText(value);
		filterData(value);
  };

  const filterData = (query: string) => {
    const filteredResults = stocks.filter((item) =>
      item.itemName.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredResult(filteredResults);
  };

  const deleteSelected = (itemName: string) => {
    const updatedChildViews = sellItems.filter((item) => item.itemName !== itemName);
    setSellItems(updatedChildViews);
  };

  const handleCheckboxChange = ( name: string) => {
		if (oneOnly === name.toString()) {
			setOneOnly('')
		} else {
			setOneOnly(name)
		}

	};

  const onToggleSwitch = () => {
    setIsSwitchOn(!isSwitchOn);
  };

  const handleBackdated = () => {
    setShowBackdated((prev) => !prev)
  };

  const receiptTime = {
    someField: 'receiptTime',
    receiptTime: serverTimestamp(),
  };
  // To convert the server timestamp to a JavaScript Date object
  const handleClearList = () => {
    setSellItems([]);
    setCustomerName('');
    setPhone('');
    setDiscount('');
    setValue('');
    setOneOnly('');
  }

  function generateReceiptID(): string {
    const timestamp = new Date().toISOString().replace(/[^0-9]/g, ''); // Format: YYYYMMDDHHMMSS
    const randomPart = Math.floor(Math.random() * 10000).toString().padStart(4, '0'); // 4-digit random number
    
    const receiptID = `SARCPT${timestamp}-${randomPart}`;
    return receiptID;
  }

  const correctedDate = async() => {
    await addDoc(collection(db, companyDir, branch, 'receipt'), receiptTime)
      .then((docRef) => {
        console.log('Document written with ID: ', docRef.id);
    
        // Retrieve the data from the added document
        return getDoc(docRef);
      })
      .then((documentSnapshot) => {
        if (documentSnapshot.exists()) {
          // Data exists in the document
          const data = documentSnapshot.data().receiptTime.toDate();

          const date = new Date(data);

          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
          const year = date.getFullYear();

          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');

          const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    
          // Delete the document
          return deleteDoc(documentSnapshot.ref);
        } else {
          console.log('Document does not exist.');
        }
      })
      .then(() => {
        console.log('Document deleted');
      })
      .catch((error) => {
        console.error('Error:', error);
      });

  }

  const correctDate = async () => {
    try {
      const docRef = await addDoc(collection(db, companyDir, branch, 'receipt'), receiptTime);
      console.log('Document written with ID: ', docRef.id);
  
      const documentSnapshot = await getDoc(docRef);
      if (documentSnapshot.exists()) {
        const data = documentSnapshot.data().receiptTime.toDate();
        const date = new Date(data);
        
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  
        // Delete the document
        await deleteDoc(documentSnapshot.ref);
  
        // Return the formatted date
        return formattedDate;
      } else {
        console.log('Document does not exist.');
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  };

  const proceedToReceipt = async () => {
    const _salesID = generateReceiptID();
    const correctDateTime = await correctDate()
    setResult('');
    
    setShowBackdated(false);
    if (sellItems.length > 0) {
    
      if (company_Name.trim() === '' || company_Address.trim() === '' || company_Phone.trim() === '') {
        window.alert('Company Data not found.\nThe company data is not found, it seems it has not yet been set.');
        return;
      }

      receiptData.name = company_Name;
      receiptData.address = company_Address;
      receiptData.phone = company_Phone;
      receiptData.salesID = _salesID;
      receiptData.salesPerson = profileName;
      receiptData.date = correctDateTime;
      receiptData.payment = value;
      receiptData.customer = customerName;
      receiptData.total = String(Number(totalDue).toLocaleString('en-NG', {}));
      receiptData.discount = '-' + String(Number(discount).toLocaleString('en-NG', {}));
      receiptData.totalPaid = String((Number(totalDue) - Number(discount)).toLocaleString('en-NG', {}))
      console.log(receiptData);
      createAndSavePDF(salesData, receiptData);
      
      try {
        // Create a new document in the 'Sales_Record' collection
        const salesRecordRef = await addDoc(collection(db, companyDir, branch, 'salesRecord'), {
          customerName: customerName,
          salesPerson: profileName,
          phoneNumber: phone,
          date: serverTimestamp(),
          salesId: _salesID,
          paymentMethod: value,
          total: parseInt(totalDue, 10),
          discount: Number(discount),
          afterDiscount: Number(totalDue) - Number(discount),
        });
    
        if (salesRecordRef) {
          const id = salesRecordRef.id;
          let count = 0;
          sellItems.forEach((row) => {
            count += row.quantity;
          });
    
          // Process and insert data into 'Sales_Items' and update 'Stocks'
          sellItems.forEach(async (row) => {
            const itemRow = filteredResult.find((item) => item.itemName === row.itemName);
            itemRow ? (itemRow.quantity = itemRow.quantity - row.quantity) : null;
    
            // Calculate discount amount for the item
            const discountAmt = (Number(discount) / count) * row.quantity;
    
            // Create a new document in 'Sales_Items' collection
            addDoc(collection(db, companyDir, branch, 'salesItems'), {
              salesId: id,
              quantity: row.quantity,
              board: row.itemName,
              customer: customerName,
              paymentMethod: value,
              date: serverTimestamp(),
              delivered: row.delivered,
              notes: row.notes,
              itemPrice: row.itemPrice,
              total: row.subTotal,
              discount: discountAmt,
              afterDiscount: row.subTotal - discountAmt,
            });
    
            // Update 'Stocks' collection
            const stocksColRef = collection(db, companyDir, branch, 'stocks');
            const stocksDocSnapshot = await getDocs(query(stocksColRef, where ('itemName', '==', itemRow.itemName))
            );
            const newQuantity = itemRow.quantity;
           
            updateDoc(stocksDocSnapshot.docs[0]?.ref, { quantity: itemRow.quantity });
          });
    
          // Reset form data
          setSellItems([]);
          setCustomerName('');
          setPhone('');
          setDiscount('');
          setValue('');
          setOneOnly('');
          setSalesData([]);
        }
      } catch (error) {
        console.error('Error executing Firestore query', error);
      }

    } else {
      console.log(Date.now().toString())
      window.alert('Empty List!\nThere is no sales to process')
    }
  };
  
  const SavedForLater = async () => {
    setResult('');
    if (resultReceived === 'Backdated') {
      setShowBackdated(true);
      setResult('ShowBackdated');
    } else {
      setShowBackdated(false);
      if (sellItems.length > 0) {
        try {
          // Create a new document in the 'SFLSales_Record' collection
          const salesRecordRef = await addDoc(collection(db, companyDir, branch, 'sFLSalesRecord'), {
            customer_Name: customerName,
            phoneNumber: phone,
            Date: new Date(), // Use the current date
            paymentMethod: value,
            total: parseInt(totalDue, 10),
            discount: Number(discount),
            afterDiscount: Number(totalDue) - Number(discount),
          });
      
          if (salesRecordRef) {
            const id = salesRecordRef.id;
            let count = 0;
            sellItems.forEach((row) => {
              count += row.quantity;
            });
      
            // Process and insert data into 'SFLSales_Items'
            sellItems.forEach((row) => {
              const itemRow = filteredResult.find((item) => item.itemName === row.itemName);
      
              // Calculate discount amount for the item
              const discountAmt = (Number(discount) / count) * row.quantity;
      
              // Create a new document in 'SFLSales_Items' collection
              addDoc(collection(db, companyDir, branch, 'sFLSalesItems'), {
                salesId: id,
                quantity: row.quantity,
                Board: row.itemName,
                customer: customerName,
                paymentMethod: value,
                Date: new Date(), // Use the current date
                delivered: row.delivered,
                notes: row.notes,
                itemPrice: row.itemPrice,
                total: row.subTotal,
                discount: discountAmt,
                afterDiscount: row.subTotal - discountAmt,
              });
            });
      
            // Reset form data and display a success alert
            window.alert('Successful\nThis sales record has been saved');
            setSellItems([]);
            setCustomerName('');
            setPhone('');
            setDiscount('');
            setValue('');
            setOneOnly('');
          }
        } catch (error) {
          console.error('Error executing Firestore query', error);
        }

      } else {
        window.alert('Empty List!\nThere is no sales to save')
      }
    }
  };

  const onPhoneBlur = async() => {
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
      tx.executeSql(`SELECT Customer_Name FROM Sales_Record WHERE Phone_Number = ?`, [phone], (_, result) => {
        console.log(result.rows.item(0), 'CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC')
        if (result.rows.length > 0) {
          setCustomerName(result.rows.item(0).Customer_Name)
        }
      })
    })
  }

  const handlePhone = (text:string) => {
    const digitsOnly = text.replace(/[^0-9]/g, '');
    setPhone(digitsOnly)
  }
  
  const handleDiscount = (text:string) => {
    const digitsOnly = text.replace(/[^0-9]/g, '');
    setDiscount(digitsOnly)
  }
  
  
  const switchText = isSwitchOn ? 'Checkbox shown' : 'Checkbox hidden';
	const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [items, setItems] = useState([
    {label: 'Cash', value: 'Cash', icon: () => <IconButton icon="cash" iconColor={darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />},
    {label: 'POS', value: 'POS', icon: () => <IconButton icon="credit-card" iconColor={darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />},
		{label: 'Bank transfer', value: 'Bank transfer', icon: () => <IconButton icon="bank-transfer" iconColor={darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />}

	]);
  const [customerName, setCustomerName] = useState('');
  const [phone, setPhone] = useState('');
  const [discount, setDiscount] = useState('');

  const [handleChecked, setHandleChecked] = useState(true)

	return (
		<PaperProvider>
			<View style={{ flex: 1 }}>
				<View style={stylesBox.mainView}>
					<View style={stylesBox.firstSubView}>
						<Switch
							value={isSwitchOn}
							onValueChange={onToggleSwitch}
							thumbColor={isSwitchOn ? 'white' : darkColour}
							trackColor={{ false: 'transparent', true: darkColour }}
							style={{ marginTop: -2, marginLeft: 8 }}
						/>
						<Text style={{ ...stylesBox.columnHeaderText, color: darkColour, marginTop: 8 }}>
							{switchText}
						</Text>
					</View>
		
					<View style={stylesBox.searchMainContainer}>
						<View style={{ flexDirection: 'row', width:380 }}>
							<TextInput
								mode="outlined"
								label={'Search stock'}
								placeholder="Search"
								underlineColor={darkColour}
								activeOutlineColor={darkColour}
								spellCheck={false}
								contentStyle={stylesBox.searchContentStyle}
								style={{  paddingVertical:1, paddingLeft:15, height: 30 }}
								outlineStyle={{ borderWidth: 0, height: 30}}
								onChangeText={handleSearchTextChange}
							/>
						</View>
					</View>
				</View>
				<View style={{flexDirection:'row'}}>
          <View style={stylesBox.stockViewBox}>
            <View style={stylesBox.stockViewHeader}>
              <View style={{ ...stylesBox.columnHeaderBox, marginLeft: isSwitchOn ? 34 : -2 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Qty</Text>
              </View>
              <View style={{ ...stylesBox.columnHeaderBox, width: 340 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Board Description</Text>
              </View>
              <View style={{ ...stylesBox.columnHeaderBox, width: isSwitchOn ? 155 : 191 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Price per Board (₦)</Text>
              </View>
            </View>
            <ScrollView>
              {filteredResult.map((item, index) => (
                <ChildView
                  key={item.itemName}
                  texts={[item.quantity.toString(), item.itemName, 
                    item.itemPrice ? Number(item.itemPrice).toLocaleString('en-NG') : '0.00']}
                  isChecked={oneOnly === item.itemName ? true : false}
                  onCheckboxChange={() => handleCheckboxChange( item.itemName)}
                  showCheckbox={isSwitchOn}
                  index={index}
                  id={item.itemName}
                  name= {item.itemName}
                  isZero = {item.quantity < 1 ? true : false}
                  clickedItem={() => SmallDialog( item.itemName, item.itemPrice, item.quantity)}
                />
              ))}
            </ScrollView>
            <Portal>
              <Modal visible={showModal} onDismiss={() => {setShowModal(false); setOneOnly('')}} contentContainerStyle={stylesBox.modalContainer}>
                <View>
                  <View style ={stylesBox.modalChild}>
                    <TextInputTemp refObject={qtyRef} lTxt="Qty" plhrTxt="Quantity" cnWidth={250} 
                      txtWidth={150} lbWidth={100} makeDigits ={true} onChangeText={qtyInput} 
                      enterKeyIsSunmit = {true} onSubmit={handleAddItem}
                    />
                    <View style={{alignSelf:'center'}}>
                      <ReactText
                        placeholder= 'Notes, if any'
                        multiline
                        numberOfLines={4}
                        spellCheck ={false}
                        style={stylesBox.notesText}
                        onChangeText={(text)=> setNotesText(text)}
                      />
                    </View>
                    <View style={stylesBox.modalButtonContainer}>
                      <View>
                        <MyButton btnText="Add" btnWidth={100} hndClicked={handleAddItem} />
                      </View>
                    </View>
                  </View>
                </View>
              </Modal>
            </Portal>
          </View>
          <View style={{flexDirection:'column'}}>
            <View style={stylesBox.sellItemContainer}>
              <View style={stylesBox.sellItemHeader}>
                <View style={{ ...stylesBox.columnHeaderBox, marginLeft: -2 }}>
                  <Text style={{ ...stylesBox.columnHeaderText }}>Qty</Text>
                </View>
                <View style={{ ...stylesBox.columnHeaderBox, width: 290 }}>
                  <Text style={{ ...stylesBox.columnHeaderText }}>Board Description</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width: 300}}>
                  <Text style={{...stylesBox.columnHeaderText}}>Notes</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width:100}}>
                  <Text style={{...stylesBox.columnHeaderText}}>Amount (₦)</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width:150 }}>
                  <Text style={{...stylesBox.columnHeaderText}}>Total Amount (₦)</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width:40 }}>
                <IconButton icon="send-check" iconColor='white' size={22} 
                  style={{width:40, height:35, marginTop: 0, padding:4}} 
                  containerColor={darkColour} focusable={false} />
                </View>
                <View style={{ ...stylesBox.columnHeaderBox, width: 36, borderRightWidth:0 }}>
                  <Text style={{ ...stylesBox.columnHeaderText }}></Text>
                </View>
              </View>

              <ScrollView>
                {sellItems.map((item, index) => (
                  <ToBeSold
                    key={item.itemName}
                    texts={[item.quantity.toString(), item.itemName, item.notes, 
                      item.itemPrice ? Number(item.itemPrice).toLocaleString('en-NG') : '0.00', 
                      item.subTotal ? Number(item.subTotal).toLocaleString('en-NG') : '0.00']}
                    index={index}
                    id={item.itemName}
                    isChecked= {item.delivered === 'Yes' ? true : false}
                    onCheckboxChange={(value)=> { setHandleChecked((prev) => !prev); value ? item.delivered = 'Yes' : item.delivered = 'No';}}
                    delPressed={() => deleteSelected(item.itemName)}
                  />
                ))}
              </ScrollView>
              {sellItems.length > 0 &&
                <View style = {{...stylesBox.firstSubView, alignSelf: 'flex-end', borderColor: darkColour, width: 240, marginRight: 2, justifyContent: 'center'}}>
                  <Text style= {{...stylesBox.columnHeaderText, fontWeight:'900', color: darkColour, fontSize: 16, alignSelf: 'center', marginTop: 0}}>
                    {`Sum Total: ${Number(totalDue).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}`}
                  </Text>
                </View>
              }

              <View style={{flexDirection:'row', justifyContent: 'space-evenly'}}>
                <View style={{flexDirection:'row'}}>
                  <TextInputTemp 
                    lTxt="Customer Name" 
                    plhrTxt="    Name of Customer" 
                    cnWidth={200} 
                    lbClr={darkColour} 
                    lbWidth={0} 
                    txtWidth={200} 
                    scTxt={false}
                    onChangeText={(value)=> setCustomerName(value)}
                    value= {customerName}
                  />
                </View>

                <View style={{flexDirection:'row'}}>
                  <TextInputTemp 
                    lTxt="Phone: +234" 
                    plhrTxt="   Phone number" 
                    cnWidth={260} 
                    lbClr={darkColour} 
                    lbWidth={110} 
                    txtWidth={150} 
                    scTxt={false}
                    value= {phone}
                    optionalError={phoneOptionalError}
                    errorMessage='Phone number may be incorrect'
                    showError = {errorPhone} 
                    focusReceived={()=> setPhoneOptionalError(false)}
                    blurHandled = {false}
                    blurHandledFunction={()=>onPhoneBlur()}
                    onChangeText={handlePhone}
                  />
                </View>
              
                <View style={{width:210, height:40, margin:10}}>
                  <DropDownPicker
                    theme="DARK"
                    modalAnimationType='slide'
                    placeholder='Payment Method'
                    style={{borderRadius:10, height:40}}
                    open={open}
                    value={value}
                    items={items}
                    setOpen={setOpen}
                    setValue={setValue}
                    setItems={setItems}
                    listItemContainerStyle={{backgroundColor:'white'}}
                    listItemLabelStyle={{color:'black', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
                    textStyle={{color:'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
                    placeholderStyle={{color:'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300', textAlign:'center'}}
                    dropDownDirection="TOP"
                  />
                </View>
                {sellItems.length > 0 &&
                <View style={{flexDirection:'row'}}>
                  <TextInputTemp 
                    lTxt="Discount (₦)" 
                    plhrTxt="Enter Discount" 
                    cnWidth={240} 
                    lbClr={darkColour} 
                    lbWidth={110} 
                    txtWidth={170} 
                    scTxt={false}
                    onChangeText={handleDiscount}
                    value= {discount}
                  />
                </View>
                }
              </View>
              <View style={stylesBox.footerContainer}>
                <View style={stylesBox.footerSubContainer}>
                  <Text style={{...stylesBox.columnHeaderText, color:'white', marginTop:0}}>
                    Total amount to pay
                  </Text>
                  <IconButton
                    icon="ray-start-arrow"
                    iconColor= 'white'
                    size={40}
                    focusable={false}
                    style={stylesBox.footerIconStyle}
                  />
                </View>
                <View style={stylesBox.totalContainer}>
                  <Text style= {{...stylesBox.columnHeaderText, fontWeight:'900'}}>
                  {(Number(totalDue) - Number(discount)).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                  </Text>
                </View>
              </View>
            </View>
            <View style={stylesBox.lastContainer}>
              <View style={{flex:1}}>
                {sellItems.length > 0 && 
                <View style={{margin:10, alignSelf:'flex-start'}}>
                  <MyButton btnText="Clear list" btnBorClr={darkColour} btnColor="white" 
                  btnBorWdt={2} btnTxtClr={darkColour} btnPadding={8} hndClicked={handleClearList}/>
                </View>
                }
              </View>
              <View style={{flex:1}}>
                <View style={{margin:10, alignSelf:'center'}}>
                  <MyButton btnText="Save for later" btnColor={darkColour} hndClicked={SavedForLater}/>
                </View>
                {result === 'ShowBackdated' && (
                  <Backdated onClicked={handleBackdated} backdated={showBackdated} />
                )}
              </View>
              <View style={{flex:1}}>
                <View style={{margin:10, alignSelf:'flex-end'}}>
                  <MyButton btnText="Proceed to receipt" btnColor={darkColour} hndClicked={proceedToReceipt}/>
                </View>
                {result === 'ShowBackdated' && (
                  <Backdated onClicked={handleBackdated} backdated={showBackdated} />
                )}
              </View>
            </View>
          </View>
        </View>
      </View>
		</PaperProvider>
	)
}

const stylesBox=StyleSheet.create ({
  purchasedTouchable: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: 'transparent',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
  viewStyle: {
		borderWidth: 2, 
		borderColor: 'black', 
		height: 35, 
		alignItems: 'center', 
		marginLeft: -2, 
		borderTopWidth: 0, 
		borderBottomWidth: 0,
	},
	textStyle: {
		color: darkColour,
		fontFamily: 'century gothic', 
		fontSize: 15, 
		fontWeight: 'normal',
		marginTop: 6,
	},
	childPressable: {
		flexDirection: 'row',
		alignItems: 'center',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
  iconButtonStyle: {
    justifyContent:'center', 
    padding:0, 
    margin:0, 
    marginLeft: -5, 
    alignContent:'center',
  },
  searchMainContainer: {
		flexDirection: 'column',
		backgroundColor: 'white',
		alignSelf: 'center',
		borderWidth: 2,
		borderColor: '#DCE3E8',
		borderRadius: 10,
		marginLeft: 10,
		marginTop: 10,
		marginBottom: 10,
		height: 40
	},
	columnHeaderText: {
	fontFamily:'century gothic', 
	fontSize:15, 
	fontWeight:'normal', 
	textAlign:'center',
	color:'white', 
	marginTop:6
	},
  searchContentStyle: {
    marginTop:-2, 
    marginLeft:-15,
		paddingTop: 2,
		paddingBottom: 0,
		borderWidth: 2,
		borderRightWidth: 0,
		borderRightColor: 'white',
		width: 380,
		height: 30,
		borderRadius: 10,
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		borderColor: 'transparent',
	},
  modalChild: {
    width: 400, 
    height:200, 
    borderWidth:2, 
    borderRadius:10, 
    borderColor:darkColour, 
    backgroundColor:'white',
  },
  modalButtonContainer: {
    width:400, 
    flexDirection:'row-reverse', 
    paddingRight:20
  },
  stockViewBox: {
		width: 580,
		height: 600,
		borderWidth: 2,
		borderColor: '#DCE3E8',
		marginTop: 10,
		marginBottom: 0,
		borderRadius: 10,
		marginLeft: 20,
		marginRight: 20,
		backgroundColor: 'white',
	},
  sellItemContainer: {
    width:960,
    height: 600,
    borderWidth: 2,
    borderColor: '#DCE3E8',
    marginTop: 10,
    marginBottom: 0,
    borderRadius: 10,
    marginLeft: 0,
    marginRight: 20,
    backgroundColor: 'white',
  },
  sellItemHeader: {
    width: 957,
    height: 35,
    backgroundColor: darkColour,
    flexDirection: 'row',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
	stockViewHeader: {
		width: 577,
		height: 35,
		backgroundColor: darkColour,
		flexDirection: 'row',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
	mainView: {
		flexDirection: 'row', 
		backgroundColor: 'white', 
		borderWidth: 2, 
		borderRadius: 10, 
		marginLeft: 20, 
		marginRight: 20, 
		borderColor: '#DCE3E8',
	},
	firstSubView: {
		borderWidth: 2,
		borderRadius: 10,
		borderColor: '#DCE3E8',
		flexDirection: 'row',
		alignSelf: 'center',
		alignContent: 'center',
		width: 208,
		height: 40,
		margin: 20,
		marginTop: 0,
		marginBottom: 0
	},
	modalContainer: {
		marginLeft:600,
		marginTop: -50,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'white',
		flexDirection:'column-reverse', 
		width:400, 
		height:200, 
		borderWidth:1, 
		borderColor:darkColour, 
		borderRadius:10, 
  },
	notesText: {
    borderWidth: 1,
    borderRadius:10,
    borderColor: '#DCE3E8',
    width:360,
    height:80,
    padding:10,
    color:'black', 
    fontFamily:'century gothic', 
    fontSize:16, 
    fontWeight:'300',
    marginBottom:10,
    marginHorizontal:0,
    alignSelf:'center'
  },

	columnHeaderBox: {
		borderWidth:2, 
		borderColor:'black', 
		width:57,  
		height:35, 
		alignItems:'center',
		marginLeft:-2,
		borderTopWidth:0,
	},
	
	mediumText: {
    color:'grey', 
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    marginTop:5
	},
  totalContainer : {
    flexDirection:'row', 
    justifyContent:'center', 
    borderWidth:2, 
    marginRight: 48,
    borderLeftWidth:0, 
    borderRightWidth:0, 
    marginTop:0, 
    borderColor:'white', 
    width:152, 
    height:35, 
    alignSelf: 'center',
  },
  footerContainer : {
    flexDirection:'row', 
    alignSelf:'center', 
    height: 40, 
    backgroundColor: darkColour, 
    borderRadius: 10, 
    borderTopRightRadius: 0, 
    borderTopLeftRadius: 0, 
    alignContent: 'center',
  },
  footerSubContainer : {
    flexDirection:'row', 
    alignSelf:'flex-end', 
    flex: 1, 
    paddingHorizontal: 100, 
    height: 40, 
    justifyContent:'flex-end', 
    alignItems:'center',
  },
  footerIconStyle: {
    marginHorizontal:20, 
    margin: 0, 
    padding: 0, 
    alignSelf: 'center',
  },
  lastContainer : {
    flexDirection:'row', 
    borderRadius:10, 
    borderColor:'#DCE3E8', 
    borderWidth:2, 
    width:960, 
    marginTop:10, 
    marginRight:20, 
    backgroundColor:'white',
  },
			
})

export default NewSales
